import React from "react"
import styled from "styled-components"
import PropTypes from "prop-types"

import media from "../../styles/media"
import { replaceLinksWithNewTabLinks } from "../../utils/common/content"

const Wrapper = styled.div`
  grid-column-end: span 4;

  font-size: 16px;
  line-height: 24px;

  ${media.tablet`
    grid-column-end: span 12;
    font-size: 20px;
    line-height: 32px;
  `}

  ${media.desktop`
    grid-column-end: span 6; 
  `}

  p {
    margin: 0 0 32px 0;
    padding: 0;
  }
`

export function BodyCopy({ body, wrapperRef }) {
  return (
    <Wrapper
      ref={wrapperRef}
      dangerouslySetInnerHTML={{ __html: replaceLinksWithNewTabLinks(body) }}
    />
  )
}

BodyCopy.propTypes = {
  body: PropTypes.string,
  wrapperRef: PropTypes.any,
}
